import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > div:last-child {
    margin-top: 40px;
  }
`
